<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import StatusClassDistributionBar from "@/components/StatusDistribution/StatusClassDistributionBar.vue";
import { boardKey } from "@/components/board/injectKeys";
import { isBacklogBoard, isSolutionBoard } from "@/model/board";
import { isDependency } from "@/model/stickyType";
import { useWorkModeStore } from "@/store/workMode";
import { isStatusDistributionFromGraph } from "@/utils/env/feature";
import { injectStrict } from "@/utils/vue";

import { cardKey } from "../injectKeys";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);
const route = useRoute();

const isProgressBarVisible = computed(
  () =>
    (isDependency(card) || isBacklogBoard(card.type.origin)) &&
    useWorkModeStore().isExecutionMode &&
    (!isSolutionBoard(board.value.type) || isStatusDistributionFromGraph(route)),
);
</script>

<template>
  <div v-if="isProgressBarVisible" class="sticky-note-progress">
    <StatusClassDistributionBar
      :value="card.statusDistribution"
      :state="card.statusDistributionState"
      source-item-type="sticky"
      :filters="{ stickyId: card.id }"
      :title="card.text"
      :show-actions="!isSolutionBoard(board.type)"
    />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/z-index";

$height: 12px;

.sticky-note-progress {
  position: absolute;
  left: 0;
  right: 0;
  height: $height;
  bottom: $height * -1;
  z-index: z-index.$progress-bar;

  // Inherited by the nested bar chart
  --distribution-border-width: 0px; // stylelint-disable-line length-zero-no-unit -- internal calc() needs a unit

  :deep(.stacked-bar-chart .bordered) {
    border-radius: 0 0 20px 20px;
  }
}
</style>
